String.prototype.firstLetterToUppercase = function () {
    return this[0].toUpperCase() + this.slice(1);
};

export const trim = (text: string) => {
    return text
        .trim()
        .replace(/\n{1,}[ \f\r\t\v]{1,}|[ \f\r\t\v]{1,}\n{1,}|\n{2,}/, "\n")
        .replace(/[ \f\r\t\v]{2,}/g, " ");
};
